export default "__VITE_ASSET__aoaPhBzI__"